<!-- <app-consultant-admin *ngIf="admin">
</app-consultant-admin>
<app-consultant-farmer  *ngIf="farmer"></app-consultant-farmer> -->

<!-- <app-tips-management>
    
</app-tips-management> -->

<!-- <app-tips-management *ngIf="((superAdmin || superUser || subAdmin)) else farmerManagement"></app-tips-management> -->

<app-tips-management >
</app-tips-management>
